import { Component, Input, OnInit } from "@angular/core";
import { Development, legendColorCollection } from "@models/development.model";
import Chart from "chart.js/auto";
import {
  doughnutChartTopTitle,
  doughnutChartBottomTitle,
  doughnutChartBottomText,
  currencyFormatter,
  numberFormatter,
  doughnutChartTitleText,
  chartFontFamily,
} from "src/app/constants/charts-const";
import ChartDataLabels from "chartjs-plugin-datalabels";

@Component({
  selector: "app-doughnut-chart",
  templateUrl: "./doughnut-chart.component.html",
  styleUrls: ["./doughnut-chart.component.scss"],
})
export class DoughnutChartComponent implements OnInit {
  @Input() development!: Development;
  doughnutChart: any;
  completedCapital = 0;
  activeCapital = 0;
  plannedCapital = 0;
  onHoldCapital = 0;
  totalCapital = 0;
  chartTitle = doughnutChartTitleText.toString();
  chartLegends: legendColorCollection[] = [];
  ngOnInit(): void {
    this.completedCapital = 0;
    this.activeCapital = 0;
    this.plannedCapital = 0;
    this.onHoldCapital = 0;
    this.getChartData();
    this.totalCapital =
      this.completedCapital + this.activeCapital + this.plannedCapital + this.onHoldCapital;
    this.createDoughnutChart();
    this.getChartLables();
  }

  getChartData(): void {
    this.development.areasOfWork
      .flatMap((c) => c.projects)
      .forEach((x) => {
        if (x.projectStatus.toLocaleLowerCase().includes("active")) {
          this.activeCapital += x.otherDevelopments.length <= 1 ? x.projectTotalBudget : 0;
        } else if (x.projectStatus.toLocaleLowerCase().includes("completed")) {
          this.completedCapital += x.otherDevelopments.length <= 1 ? x.projectTotalBudget : 0;
        } else if (x.projectStatus.toLocaleLowerCase().includes("planned")) {
          this.plannedCapital += x.otherDevelopments.length <= 1 ? x.projectTotalBudget : 0;
        } else if (x.projectStatus.toLocaleLowerCase().includes("on hold")) {
          this.onHoldCapital += x.otherDevelopments.length <= 1 ? x.projectTotalBudget : 0;
        }
      });
  }

  createDoughnutChart() {
    this.doughnutChart = new Chart("doughnutChart", {
      type: "doughnut",
      data: {
        labels: [
          `Completed - ${
            (isNaN(this.roundUp((this.completedCapital / this.totalCapital) * 100))
              ? 0
              : this.roundUp((this.completedCapital / this.totalCapital) * 100)) + "%"
          }`,
          `Active - ${
            (isNaN(this.roundUp((this.activeCapital / this.totalCapital) * 100))
              ? 0
              : this.roundUp((this.activeCapital / this.totalCapital) * 100)) + "%"
          }`,
          `On Hold - ${
            (isNaN(this.roundUp((this.onHoldCapital / this.totalCapital) * 100))
              ? 0
              : this.roundUp((this.onHoldCapital / this.totalCapital) * 100)) + "%"
          }`,
          `Planned - ${
            (isNaN(this.roundUp((this.plannedCapital / this.totalCapital) * 100))
              ? 0
              : this.roundUp((this.plannedCapital / this.totalCapital) * 100)) + "%"
          }`,
        ],
        datasets: [
          {
            data: [
              Math.round(this.completedCapital),
              Math.round(this.activeCapital),
              Math.round(this.onHoldCapital),
              Math.round(this.plannedCapital),
            ],
            backgroundColor: [
              "rgba(37, 89, 136, 1)",
              "rgba(8, 99, 101, 1)",
              "rgba(112,128,144, 1)",
              "rgba(111, 160, 181, 1)",
            ],
            datalabels: {
              color: "#FFFFFF",
              padding: { bottom: 50 },
              textAlign: "end",
              font: {
                weight: "bolder",
                size: 14,
              },
            },
            hoverOffset: 4,
          },
        ],
      },
      plugins: [ChartDataLabels],
      options: {
        plugins: {
          title: doughnutChartTopTitle,
          // subtitle: {
          //   ...doughnutChartBottomTitle,
          //   text: `${doughnutChartBottomText}${currencyFormatter.format(
          //     this.getFiveYearProjectBudget(),
          //   )}`,
          // },
          legend: {
            position: "bottom",
            display: false,
            labels: {
              color: "#000000",
              boxWidth: 12,
              font: {
                size: 12,
                weight: "bolder",
                family: chartFontFamily,
              },
            },
          },
          datalabels: {
            display: true,
            formatter: (value, context) => {
              return this.roundUp((value / this.totalCapital) * 100) <= 0
                ? ""
                : this.roundUp((value / this.totalCapital) * 100) + "%";
            },
            // formatter: (value, context) => {
            //   return this.development.totalInvestment == value
            //     ? Math.round(
            //         100 -
            //           this.roundUp(
            //             (this.getFiveYearProjectBudget() / this.development.totalInvestment) * 100,
            //           ),
            //       ) + "%"
            //     : Math.round(
            //         this.roundUp(
            //           (this.getFiveYearProjectBudget() / this.development.totalInvestment) * 100,
            //         ),
            //       ) + "%";
            // },
            font: {
              size: 16,
              weight: "bolder",
              family: chartFontFamily,
            },
          },
        },

        scales: {
          y: {
            display: false,
            grid: {
              display: false,
            },
          },
          x: {
            display: false,
            grid: {
              display: true,
            },
          },
        },
        aspectRatio: window.innerWidth <= 1280 ? 1.4 : 1.5,
      },
    });
  }

  getFiveYearProjectBudget(): number {
    return this.development.areasOfWork
      .flatMap((x) => x.fiveYearCapitalNeeds)
      .reduce((acc, cur) => acc + Number(cur), 0);
  }

  roundUp(num: number) {
    return Math.round(Math.floor(num * 100) / 100);
    // return Math.round((num + Number.EPSILON) * 100) / 100;
  }

  getChartLables() {
    this.chartLegends.push({
      legendName: `Completed - ${
        (isNaN(this.roundUp((this.completedCapital / this.totalCapital) * 100))
          ? 0
          : this.roundUp((this.completedCapital / this.totalCapital) * 100)) + "%"
      }`,
      colorCoding: "rgba(37, 89, 136, 1)",
    });
    this.chartLegends.push({
      legendName: `Active - ${
        (isNaN(this.roundUp((this.activeCapital / this.totalCapital) * 100))
          ? 0
          : this.roundUp((this.activeCapital / this.totalCapital) * 100)) + "%"
      }`,
      colorCoding: "rgba(8, 99, 101, 1)",
    });
    this.chartLegends.push({
      legendName: `On Hold - ${
        (isNaN(this.roundUp((this.onHoldCapital / this.totalCapital) * 100))
          ? 0
          : this.roundUp((this.onHoldCapital / this.totalCapital) * 100)) + "%"
      }`,
      colorCoding: "rgba(112,128,144, 1)",
    });
    this.chartLegends.push({
      legendName: `Planned - ${
        (isNaN(this.roundUp((this.plannedCapital / this.totalCapital) * 100))
          ? 0
          : this.roundUp((this.plannedCapital / this.totalCapital) * 100)) + "%"
      }`,
      colorCoding: "rgba(111, 160, 181, 1)",
    });
  }
}
